import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';

import { Item2ReturnPolicyData } from '../schemas/rql';
import ListingNudge from './discovery/listing_nudge';

const RETURN_WINDOW_MIN = 14;

export interface IProps {
  listing: Item2ReturnPolicyData.Fragment;
  oneLineDisplay: Boolean;
}

function getSubtitleText() {
  return I18n.t('discovery.item2ReturnPolicy.subtitle');
}

function getReturnWindowText(returnWindow) {
  return I18n.t('discovery.item2ReturnPolicy.returnWindow', { returnWindow });
}

export default function Item2ReturnPolicy(props: IProps) {
  if (!props.listing.shop.returnPolicy) {
    return null;
  }
  const { shop: { returnPolicy: { newReturnWindowDays, usedReturnWindowDays } }, condition } = props.listing;

  const returnWindow = condition.conditionSlug === 'brand-new' ? newReturnWindowDays : usedReturnWindowDays;

  if (returnWindow < RETURN_WINDOW_MIN) return null;
  if (props.listing.soldAsIs) return null;

  if (props.oneLineDisplay) {
    return (
      <p className="size-90 align-center mt-half opacity-70" data-nudge-title>
        {`${getReturnWindowText(returnWindow)}`}
      </p>
    );
  }

  return (
    <ListingNudge
      title={getReturnWindowText(returnWindow)}
      subtitle={getSubtitleText()}
      subclass="listing-nudge--returns"
    />
  );
}

export const Item2ReturnPolicyFragment = gql`
  fragment Item2ReturnPolicyData on Listing {
    _id
    condition {
      conditionSlug
    }
    shop {
      _id
      returnPolicy {
        newReturnWindowDays
        usedReturnWindowDays
      }
    }
    soldAsIs
  }
`;
